module.exports = __webpack_public_path__ + "static/media/simonSound1.319c7710.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/simonSound1.mp3
// module id = 190
// module chunks = 0